var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8849 15.1828L11.7292 10.5987C11.6574 10.5628 11.5768 10.5484 11.497 10.5572C11.4173 10.5661 11.3418 10.5979 11.2797 10.6487C11.2204 10.6985 11.1761 10.7639 11.1518 10.8375C11.1275 10.9111 11.1243 10.9901 11.1424 11.0654L12.2452 15.1369H16.9521V15.9704H12.2452L11.1257 20.0294C11.1087 20.0923 11.1068 20.1584 11.1199 20.2222C11.1331 20.2861 11.161 20.3459 11.2015 20.397C11.242 20.4481 11.2939 20.4889 11.353 20.5163C11.4121 20.5436 11.4768 20.5567 11.5419 20.5544C11.607 20.554 11.6712 20.5383 11.7292 20.5086L20.8849 15.9245C20.9531 15.8896 21.0103 15.8364 21.0502 15.771C21.0902 15.7056 21.1113 15.6303 21.1113 15.5536C21.1113 15.477 21.0902 15.4017 21.0502 15.3363C21.0103 15.2709 20.9531 15.2177 20.8849 15.1828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSend);
export default __webpack_public_path__ + "static/media/chat_send.b3258898a1daab0f3591fd6f48fd0fc9.svg";
export { ForwardRef as ReactComponent };